import { API_BASE_URL } from '../config/settings';

export interface GDriveFile {
  id: string;
  name: string;
  mimeType: string;
  modifiedTime: string;
}

export interface GDriveFileContent {
  id: string;
  name: string;
  content: string;
  modifiedTime: string;
}

class GDriveService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${API_BASE_URL}/gdrive`;
  }

  // Check if connected to Google Drive
  async isConnected(): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/status`);
      const data = await response.json();
      return data.success && data.data?.connected;
    } catch {
      return false;
    }
  }

  // Start OAuth flow
  connect(): void {
    window.location.href = `${this.baseUrl}/auth`;
  }

  // Disconnect from Google Drive
  async disconnect(): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/disconnect`, {
        method: 'DELETE'
      });
      const data = await response.json();
      return data.success;
    } catch {
      return false;
    }
  }

  // List files from Google Drive
  async listFiles(): Promise<GDriveFile[]> {
    try {
      const response = await fetch(`${this.baseUrl}/files`);
      const data = await response.json();

      if (data.success && data.data) {
        return data.data;
      }
      return [];
    } catch {
      return [];
    }
  }

  // Get file content
  async getFile(fileId: string): Promise<GDriveFileContent | null> {
    try {
      const response = await fetch(`${this.baseUrl}/files/${fileId}`);
      const data = await response.json();

      if (data.success && data.data) {
        return data.data;
      }
      return null;
    } catch {
      return null;
    }
  }

  // Save file to Google Drive
  async saveFile(fileId: string, content: string): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/files/${fileId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ content })
      });
      const data = await response.json();
      return data.success;
    } catch {
      return false;
    }
  }
}

export const gdriveService = new GDriveService();
